import AddNextOfKinModal from './AddNextOfKinModal';

export default AddNextOfKinModal;
